import { g as l } from "./chunks/lib/getAppUrl.zOygEGj2.js";
import { L as p } from "./chunks/components/LoadingSpinner.57gD12TZ.js";
import { _ as d } from "./chunks/components/NavUserDropdown.VdLY4DlZ.js";
import { _ as b } from "./chunks/components/NavUnreadMessages.AO5p2IRO.js";
import { N as f } from "./chunks/components/NotAuthorised.dOkOgyZi.js";
import { N as y } from "./chunks/components/NotFound.CCmPfkUP.js";
import { _ as w } from "./chunks/components/PageFooter.BJyD29WD.js";
import { S as v } from "./chunks/components/ServiceWorkerReload.B57W5psq.js";
import { _ as C } from "./chunks/components/ToastMessages.8Si_C1Cf.js";
import { _ as M } from "./chunks/components/IdleLogoutPrompt.Ch_ZTSgf.js";
import { _ as N } from "./chunks/components/TokenRequired.Car5_azh.js";
import { _ as D } from "./chunks/components/HelpMessage.BkXPBhFi.js";
import { U as R } from "./chunks/components/UserSearch.CXAdt5PB.js";
import { A as B } from "./chunks/components/AvatarIcon.Bdl_dbsV.js";
import { M as j } from "./chunks/components/MessageAttachment.wQnbDm2L.js";
import { A as P } from "./chunks/components/AnnouncementMessage.DMHszzEQ.js";
import { _ as q } from "./chunks/components/UserDisplay.ci4YtugP.js";
import { p as H } from "./chunks/stores/index.Dc8zp5Z2.js";
import { u as O } from "./chunks/stores/auth.BA35tn65.js";
import { u as W } from "./chunks/stores/userDirectory.DjY3mCZE.js";
import { u as K } from "./chunks/stores/messaging.KQm3MfBf.js";
import { A as Q } from "./chunks/lib/api.DveR7HGv.js";
import { p as Y } from "./chunks/lib/errorhandler.CNhMajq3.js";
import { C as $ } from "./chunks/lib/CognitoCookieStorage.CrytakjS.js";
import { s as te } from "./chunks/lib/setRedirectCookie.BG84xRGr.js";
import { g as ae, r as re, s as se } from "./chunks/lib/deviceNotificationToken.V6Sa4Pxk.js";
import { g as le } from "./chunks/lib/colour.D5peZoOG.js";
import { c as pe } from "./chunks/lib/math.CqRL4S9t.js";
import { g as de, a as me, s as be } from "./chunks/lib/deviceTokenManager.Du8FAMMv.js";
import { M as fe } from "./chunks/lib/rules.B0UzfYPC.js";
import { c as ye, a as xe } from "./chunks/lib/md.BKLF13aq.js";
import { g as he, a as ve, m as ke } from "./chunks/lib/mention-link.DxJXRUCS.js";
import { u as Ae } from "./chunks/composables/usePolling.CLuBK6Be.js";
import { u as _e } from "./chunks/composables/useMessageAttachmentUrls.ycLx5Zww.js";
import { i as Te } from "./chunks/icons.s_e5IqVU.js";
import { l as Fe, p as Re, u as Ue } from "./chunks/lib/routeGuards.BGInUXFq.js";
const a = {
  locations: [
    {
      name: "Georgian House Torquay",
      value: "gh",
      city: "Torquay",
      state: "Devon"
    },
    {
      name: "Meadfoot View",
      value: "mf",
      city: "Torquay",
      state: "Devon"
    }
  ]
}, o = {
  root: {
    class: "btn"
  }
}, r = {
  button: {
    root: (e) => ({
      class: [
        "btn",
        {
          "btn btn-block btn-primary": e.props.severity == null
        },
        {
          "btn-secondary": e.props.severity === "secondary",
          "btn-success": e.props.severity === "success",
          "btn-info": e.props.severity === "info",
          "btn-warning": e.props.severity === "warning",
          "btn-purple": e.props.severity === "help",
          "btn-danger": e.props.severity === "danger"
        },
        {
          "shadow-lg": e.props.raised
        },
        {
          "opacity-25 disabled": e.context.disabled
        }
      ]
    })
  },
  dropdown: {
    root: {
      class: "form-select pt-dropdown"
    },
    trigger: "d-none",
    // hide the trigger button, form-select has a built in icon
    panel: {
      class: "rounded border pt-dropdown-panel"
    },
    header: {
      class: "pt-dropdown-header card-header p-2"
    },
    filtercontainer: {
      class: "pt-dropdown-filter-container"
    },
    filterinput: {
      class: "form-control form-control-sm"
    },
    wrapper: {
      class: "pt-dropdown-wrapper"
    },
    list: {
      class: "dropdown-menu show"
    },
    itemgroup: {
      class: "dropdown-header"
    },
    item: {
      class: "dropdown-item",
      style: "cursor: pointer"
    },
    filtericon: {
      class: "d-none"
    },
    clearicon: {
      class: "ms-1 text-danger",
      style: "cursor: pointer"
    }
  },
  select: {
    root: {
      class: "form-select d-flex align-items-center"
    },
    dropdown: {
      class: "d-none"
    },
    listcontainer: {
      class: "dropdown-menu show"
    },
    list: {
      class: "m-0 p-0"
    },
    option: {
      class: "dropdown-item"
    },
    clearicon: {
      class: "ms-1 text-danger",
      style: "cursor: pointer"
    }
  },
  datatable: {
    root: {
      class: "pt-datatable-root"
    },
    table: ({ props: e }) => ({
      class: "table table-striped table-responsive pt-datatable" + (e.rowHover ? " table-hover" : ""),
      style: e.loading ? "cursor: wait; opacity: 0.5;" : ""
    }),
    tbody: {
      class: "table-group-divider"
    },
    thead: {
      class: "table-secondary"
    },
    loadingOverlay: {
      style: "position: absolute; "
    },
    loadingIcon: {
      class: "spinner-border text-primary datatable-loading-icon"
    },
    mask: () => ({
      class: "pt-datatable-mask pt-overlay-mask"
    }),
    column: {
      headercell: {
        class: "align-top"
      },
      bodycell: {
        class: "py-1"
      },
      columntitle: {
        class: "pt-datatable-column-title text-nowrap"
      },
      columnheadercontent: {
        class: "d-flex align-items-center"
      },
      columnFilter: () => ({
        class: "d-flex pt-datatable-column-filter"
      }),
      filterInput: () => ({
        class: "flex-grow-1"
      }),
      headerFilterClearButton: ({ context: e }) => ({
        class: "ms-1 btn btn-sm" + (e.hidden ? " " : " invisible") + (e.active ? " " : " btn-danger")
      }),
      filter: {
        class: "d-flex pt-datatable-column-filter"
      },
      pcColumnFilterClearButton: {
        class: "btn btn-sm btn-outline-danger ms-1 pc-column-filter-clear"
      },
      sort: ({ context: e }) => ({
        class: "ms-1 badge rounded-pill " + (e.sorted ? "text-bg-primary" : "text-bg-secondary"),
        style: "cursor:pointer"
      }),
      pcRowCheckbox: () => ({
        box: "d-none"
      }),
      pcHeaderCheckbox: {
        // select-all checkbox in header
        box: "d-none"
      }
    },
    bodyRow: ({ context: e }) => ({
      class: "pt-datatable-row" + (e.selected ? " table-active" : "") + (e.selectable ? " " : " unselectable")
    })
  },
  paginator: {
    root: { class: "pt-paginator mb-1" },
    paginatorContainer: {
      class: "pt-datatable-paginator-wrapper"
    },
    first: {
      class: "btn btn-sm btn-outline-primary mx-1"
    },
    prev: {
      class: "btn btn-sm btn-outline-primary me-2"
    },
    next: {
      class: "btn btn-sm btn-outline-primary ms-2"
    },
    last: {
      class: "btn btn-sm btn-outline-primary mx-1"
    },
    pages: {
      class: "btn-group"
    },
    page: ({ context: e }) => ({
      class: "btn btn-sm" + (e.active ? " btn-primary" : " btn-outline-primary")
    }),
    current: {
      class: "pt-paginator-current btn btn-sm flex-grow-1 "
    },
    content: {
      class: "d-flex w-100"
    }
  },
  datepicker: {
    root: {
      class: "input-group pt-datepicker"
    },
    dropdown: {
      class: "btn btn-outline-primary"
    },
    pcInputText: {
      root: {
        class: "form-control"
      }
    },
    panel: {
      class: "dropdown-menu show pt-datepicker-panel"
    },
    calendarcontainer: {
      class: "d-flex pt-datepicker-container justify-content-center"
    },
    calendar: {
      class: "pt-datepicker-calendar"
    },
    header: {
      class: "d-flex justify-content-center align-items-center mb-2"
    },
    dayview: {
      class: "table align-middle table-sm table-bordered pt-datepicker-table"
    },
    selectmonth: {
      class: "btn btn-sm btn-outline-primary mx-1"
    },
    selectyear: {
      class: "btn btn-sm btn-outline-primary mx-1"
    },
    pcprevbutton: {
      root: {
        class: "btn-sm btn btn-outline-primary"
      }
    },
    pcnextbutton: {
      root: {
        class: "btn-sm btn btn-outline-primary"
      }
    },
    daycell: ({ context: e }) => {
      var t;
      return {
        class: "day" + (e.selected ? " selected" : " ") + ((t = e.date) != null && t.selectable ? " " : " unselectable") + (e.otherMonth ? " other-month" : "") + (e.today ? " today" : "") + (e.disabled ? " disabled" : "")
      };
    },
    monthview: {
      class: "d-flex flex-wrap justify-content-center"
    },
    month: {
      class: "btn btn-outline-primary mx-1"
    },
    yearview: {
      class: "d-flex flex-wrap justify-content-center"
    },
    year: {
      class: "btn btn-outline-primary mx-1"
    },
    title: {
      class: "mx-1"
    }
  },
  dialog: {
    root: {
      class: "pt-dialog modal-dialog modal-lg modal-fullscreen-md-down modal-content"
    },
    headeractions: {
      class: "pt-dialog-header-actions"
    },
    mask: (e) => ({
      class: [
        "modal",
        {
          show: e.state.containerVisible
        }
      ],
      style: {
        backgroundColor: "rgba(0, 0, 0, .5)"
      }
    }),
    header: { class: "modal-header" },
    footer: { class: "modal-footer" },
    content: { class: "modal-body pt-dialog-content" },
    pcCloseButton: o
  },
  drawer: {
    root: {
      class: "offcanvas offcanvas-top show pt-drawer"
    },
    mask: {
      style: "z-index: 2"
    },
    header: {
      class: "d-flex justify-content-end"
    },
    pcCloseButton: o
  },
  confirmpopup: {
    root: {
      class: "pt-confirmpopup shadow-lg"
    },
    header: { class: "modal-header pt-dialog-header" },
    footer: { class: "modal-footer p-3 pt-dialog-footer" },
    content: { class: "modal-body px-3 py-3" },
    acceptButton: {
      root: {
        class: "btn btn-primary ms-2"
      }
    },
    rejectButton: {
      root: {
        class: "btn btn-secondary ms-2"
      }
    }
  },
  popover: {
    root: {
      class: "pt-popover p-2 shadow-lg"
    },
    content: { class: "modal-body px-2 pt-2" },
    closeButton: { class: "btn btn-danger pt-popover-close" }
  }
};
export {
  P as AnnouncementMessage,
  Q as Api,
  B as AvatarIcon,
  $ as CognitoCookieStorage,
  a as Config,
  D as HelpMessage,
  M as IdleLogoutPrompt,
  p as LoadingSpinner,
  fe as MARKDOWN_RULES,
  j as MessageAttachment,
  b as NavUnreadMessages,
  d as NavUserDropdown,
  f as NotAuthorised,
  y as NotFound,
  w as PageFooter,
  r as PrimevuePassthruBootstrap,
  v as ServiceWorkerReload,
  C as ToastMessages,
  N as TokenRequired,
  q as UserDisplay,
  R as UserSearch,
  ye as createBlockMarkdown,
  xe as createInlineMarkdown,
  pe as cyrb53,
  l as getAppUrl,
  le as getColour,
  de as getDeviceToken,
  he as getMentionDataFromMarkdown,
  me as getNotificationPermission,
  ae as getNotificationTokenCookieForApp,
  Te as icons,
  Fe as loginRedirectGuard,
  ve as mention_link_render,
  ke as mention_link_rule,
  Y as parseErrorDetails,
  Re as permissionCheckGuard,
  H as pinia,
  re as removeNotificationTokenCookieForApp,
  be as saveAndRegisterDeviceToken,
  se as setNotificationTokenCookieForApp,
  te as setRedirectCookie,
  O as useAuthStore,
  K as useLibMessagingStore,
  _e as useMessageAttachmentUrls,
  Ae as usePolling,
  W as useUserDirectory,
  Ue as userCheckedGuard
};
